import React, { useState, useEffect } from 'react';

import './RoomAnywhere.css'; // Import the styles for the page
import RoomAnywhereUseCases from './RoomAnywhereUseCases';
import RoomAnywhereAdvantages from './RoomAnywhereAdvantages';
import RoomAnywhereProduct from './RoomAnywhereProduct';
import RoomAnywhereAbstract from './RoomAnywhereAbstract';
import raineximage1 from '../../assets/pageimages/roomanywhere/raindeximg1.png';
import { useLocation, useNavigate } from 'react-router-dom';
import ThinkImageGallery from './ThinkImageGallery';


const RoomAnywhere = () => {
  const navigate = useNavigate();

  const images = [
    { imageId: 1, imageName: "image1.png", imageTitle: "Collage", imageDescription: "RoomAnywhere Collage", hasVideo: false },
    { imageId: 2, imageName: "image2.png", imageTitle: "Think Stylus", imageDescription: "Think Stylus", hasVideo: true, videoURL: "/videos/stree2_1080P.mp4" },
    { imageId: 3, imageName: "image3.png", imageTitle: "Fashion", imageDescription: "Fashion", hasVideo: false },
    { imageId: 4, imageName: "image4.png", imageTitle: "Dicta Book", imageDescription: "Dicta Book", imageId: 3, isSubimage: true },
  ];
  
  
  const [imageGalleryClicked, setImageGalleryClicked] = useState(false);
  const viewImages = () => {
    setImageGalleryClicked(!imageGalleryClicked);
  }; 
  const viewDemo = () => {
    navigate('/orderflow-spotbuy');
  };
  
  const buyProduct = () => {
    navigate('/orderflow-products');
  };
  
  const resellerRequest = () => {
    navigate('/orderflow-earning-estimator');
  };


  const raCollaborate = () => {
    // navigate('/orderflow-earning-estimator');
  };

  const raBuzz = () => {
    // navigate('');
  };

  return (
    <div className="roomanywhere-container bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 min-h-screen text-white">
      <header className="header text-center py-4">
        <h1 className="title text-2xl sm:text-xl md:text-2xl font-extrabold leading-tight mb-2">
          RoomAnywhere: Unwind a Portable In-Room Experience Anywhere
        </h1>
        <p className="subtitle text-lg sm:text-lg mb-2">
          Patent Pending for Utility - Humanitarian Architecture and Privacy Solutions
        </p>
      </header>

      {/* Centered Image */}
      <div className="flex justify-center mb-8">
        <img
          src={raineximage1}
          alt="RoomAnywhere"
          className="w-1/3 h-auto max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-lg shadow-2xl"
        />
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-1 p-2 mx-auto">
        {/* Image Gallery */}
        <button
          onClick={viewImages}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg text-md font-semibold shadow-md hover:bg-blue-700 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        >
          📸 Image Gallery
        </button>

        {/* Watch Sample Demo */}
        <button
          onClick={viewDemo}
          className="bg-green-600 text-white px-6 py-2 rounded-lg text-md font-semibold shadow-md hover:bg-green-700 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        >
          🎥 Watch Sample Demo
        </button>

        {/* Order Product */}
        <button
          onClick={buyProduct}
          className="bg-purple-600 text-white px-6 py-2 rounded-lg text-md font-semibold shadow-md hover:bg-purple-700 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        >
          🛒 Order Product
        </button>

        {/* Order Accessories */}
        <button
          onClick={buyProduct}
          className="bg-purple-600 text-white px-6 py-2 rounded-lg text-md font-semibold shadow-md hover:bg-purple-700 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        >
          🎧 Order Accessories
        </button>

        {/* EMI Details */}
        <button
          onClick={buyProduct}
          className="bg-purple-600 text-white px-6 py-2 rounded-lg text-md font-semibold shadow-md hover:bg-purple-700 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        >
          💳 EMI Details
        </button>

        {/* Become a Reseller */}
        <button
          onClick={resellerRequest}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg text-md font-semibold shadow-md hover:bg-blue-700 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        >
          🤝 Become a Reseller
        </button>

        {/* Collaborate */}
        <button
          onClick={raCollaborate}
          className="bg-green-600 text-white px-6 py-2 rounded-lg text-md font-semibold shadow-md hover:bg-green-700 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        >
          🔗 Collaborate
        </button>

        {/* Buzz */}
        <button
          onClick={raBuzz}
          className="bg-purple-600 text-white px-6 py-2 rounded-lg text-md font-semibold shadow-md hover:bg-purple-700 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        >
          🚀 Buzz
        </button>

        {/* Usage Card */}
        <button
          onClick={raBuzz}
          className="bg-purple-600 text-white px-6 py-2 rounded-lg text-md font-semibold shadow-md hover:bg-purple-700 transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
        >
          📄 Usage Card
        </button>
      </div>

      {imageGalleryClicked && (
        <div>
          <ThinkImageGallery images={images} folderName="roomanywhere" />
        </div>
      )}

      {/* Overview Section */}
      <section className="overview text-center px-6 sm:px-12 md:px-24 mb-12">
        <h2 className="text-xl sm:text-xl font-bold mb-4">Overview</h2>
        <p className="text-lg sm:text-lg">
          RoomAnywhere is a groundbreaking invention, a portable modular structure designed to provide shelter for the homeless and offer versatile privacy solutions within homes. It adapts to a variety of living scenarios, offering over 343 room configurations from 16 to 100 sq ft in area.
        </p>
      </section>

      {/* Field of Invention Section */}
      <section className="field-of-invention px-6 sm:px-12 mb-12">
        <h2 className="text-xl font-bold text-yellow-200 mb-4">Field of Invention</h2>
        <p className="text-lg text-yellow-200 mb-4">
          <strong>[Field - Humanitarian Architecture and Privacy Solutions]</strong>
        </p>
        <p className="text-lg text-white mb-4">
          RoomAnywhere exemplifies the intersection of humanitarian architecture and privacy solutions, presenting a transformative tool for addressing the growing demand for temporary and modular spaces worldwide.
        </p>
        <p className="text-lg text-white mb-4">
          RoomAnywhere is an innovative portable modular structure designed to address dual societal needs—providing emergency shelters for the homeless and privacy solutions for households and shared spaces. This invention is characterized by its modularity, allowing it to create up to 343 room-like configurations ranging from 16 to 100 sq ft in area and 64 to 1000 cubic ft in volume. The system offers flexibility, portability, and quick assembly, making it adaptable for various humanitarian, residential, and commercial scenarios.
        </p>
      </section>

      {/* Inventors Information */}
      <section className="inventors-info px-6 sm:px-12 mb-12">
        <h2 className="text-xl font-bold text-center mb-4">Inventors</h2>
        <div className="inventor text-center mb-6">
          <h3 className="text-lg font-semibold">Sanjeev Kumar</h3>
          <p>Lead Inventor, Conceptualization & Design Development</p>
          <p className="text-sm">Address: B-1402, Riviera, Palava, Casa-Bella, Kalyan-Shil Road, Dombivali East, Thane, Mumbai, Maharashtra, India, PIN - 421204</p>
        </div>
        <div className="inventor text-center">
          <h3 className="text-lg font-semibold">Srishti Sinha</h3>
          <p>Co-Inventor, Structural Enhancements & Design Refinements</p>
        </div>
      </section>

      {/* Background Section */}
      <section className="background text-m px-6 sm:px-12 mb-4">
        <h2 className="text-xl font-bold mb-4">Background</h2>
        <p>
        In the heart of a bustling city, where narrow streets echo with the laughter of children and the aroma of home-cooked meals wafts from every corner, joint families thrive. Generations live under one roof, weaving a rich tapestry of love, tradition, and togetherness. But amid the warmth of shared spaces and the joy of community, a quiet yearning often emerges—one for personal space.
        </p>
        <p>
        Here, privacy is a rare luxury. A student prepares for exams at the dining table, competing with the chatter of siblings. A guest arrives unexpectedly, and the only option is a makeshift bed in the living room. A young couple dreams of a cozy nook to share tea away from prying eyes. And when disaster strikes, displacing families, the absence of emergency shelters becomes glaringly evident.
        </p>
        <p>
        Enter RoomAnywhere. More than just an invention, it’s a revolution in the way we view space. Designed with versatility at its core, RoomAnywhere adapts to life’s ever-changing needs. Need a quiet study corner? It’s there. Hosting guests overnight? It transforms effortlessly into a temporary room. Craving a peaceful retreat for tea or meditation? RoomAnywhere offers a cozy haven.
        </p>
        <p>
        But its purpose extends far beyond convenience. RoomAnywhere stands as a beacon of hope for those without homes—a modular, portable solution that provides shelter and dignity in times of crisis. With over 343 possible configurations, ranging from snug 16-square-foot spaces to expansive 100-square-foot layouts, it redefines flexibility.
        </p>
        <p>
        Imagine a family celebrating a festival, each member engaged in their traditions, while RoomAnywhere discreetly offers solace to the grandfather who wishes to read in peace. Picture a disaster-stricken area, where rows of RoomAnywhere modules rise like phoenixes, providing sanctuary to those who have lost everything.
        </p>
        <p>
        RoomAnywhere is not just about space; it’s about possibilities. It’s about finding room to dream, grow, and heal—even in the heart of the busiest cities. It’s a testament to the power of innovation, bridging the gap between community and individuality, between chaos and calm.
        </p>   
        <p>
        In a world where personal space often feels like an unattainable dream, RoomAnywhere offers a simple yet profound promise: the freedom to carve out a corner of your own, wherever life takes you.
        </p>        
      </section>

      {/* Other Sections */}
      <section className="applications">
        <RoomAnywhereUseCases />
        <RoomAnywhereProduct />
        <RoomAnywhereAdvantages />
        <RoomAnywhereAbstract />
      </section>

      {/* Footer Section */}
      <footer className="footer text-center py-6">
        <p>Contact: <a href="mailto:thinkroomanywhere@gmail.com" className="text-blue-400">thinkroomanywhere@gmail.com</a></p>
        <p>WhatsApp: +91 9324342899</p>
      </footer>
    </div>
  );
};

export default RoomAnywhere;
